// extracted by mini-css-extract-plugin
module.exports = {"ImageDesktopMobile":"styles_ImageDesktopMobile__d8uCG","hideOnSmallScreen":"styles_hideOnSmallScreen__YbE4d","hideOnLargeScreen":"styles_hideOnLargeScreen__QubB0"};